var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoData = function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404 269"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "no-data_svg__a",
    x: "-12.6%",
    y: "-48.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("circle", {
    cx: 201.876,
    cy: 134.269,
    r: 134.269,
    style: {
      fill: "#ddf5e2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#no-data_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.43 137.978h308.757a2.077 2.077 0 0 1 2.077 2.077V218.1a2.077 2.077 0 0 1-2.077 2.077H47.43a2.077 2.077 0 0 1-2.077-2.077v-78.045a2.077 2.077 0 0 1 2.077-2.077",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.353 137.978h93.911v82.197h-93.911v-82.197",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.027 209.438a.67.67 0 0 1-.943.014l-.014-.014-.039-.039c-1.868-1.842-3.088-3.048-3.042-4.552a2.17 2.17 0 0 1 .833-1.663 1.946 1.946 0 0 1 2.72.419v.007a1.94 1.94 0 0 1 2.71-.436l.014.01a2.17 2.17 0 0 1 .833 1.663c.05 1.5-1.174 2.71-3.042 4.56Z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.649 203.116h44.665a3.1 3.1 0 0 1 3.1 3.1 3.1 3.1 0 0 1-3.1 3.1H60.649a3.1 3.1 0 0 1-3.1-3.1 3.1 3.1 0 0 1 3.1-3.1",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.162 183.342h26.651a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.32 2.332H59.162a2.326 2.326 0 0 1-2.326-2.326 2.326 2.326 0 0 1 2.321-2.331ZM110.742 183.342h13.489a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.32 2.332h-13.495a2.327 2.327 0 0 1-2.327-2.327 2.326 2.326 0 0 1 2.321-2.331ZM145.6 183.342h31.276a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.32 2.332H145.6a2.327 2.327 0 0 1-2.326-2.327 2.326 2.326 0 0 1 2.321-2.331ZM196.471 183.342h52.263a2.326 2.326 0 0 1 2.326 2.326 2.327 2.327 0 0 1-2.322 2.332h-52.267a2.327 2.327 0 0 1-2.327-2.327 2.326 2.326 0 0 1 2.321-2.331Z",
    style: {
      fill: "#f7f7f7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.082 183.342h52.263a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.32 2.332h-52.269a2.326 2.326 0 0 1-2.326-2.326 2.326 2.326 0 0 1 2.321-2.331Z",
    style: {
      fill: "#e8e8e8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#no-data_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.43 99.4h308.757a2.077 2.077 0 0 1 2.077 2.077v78.043a2.077 2.077 0 0 1-2.077 2.077H47.43a2.077 2.077 0 0 1-2.077-2.077v-78.039A2.077 2.077 0 0 1 47.43 99.4",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.353 99.404h93.911v82.197h-93.911V99.404",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.027 170.864a.67.67 0 0 1-.945.012l-.012-.012-.039-.039c-1.868-1.841-3.088-3.047-3.042-4.552a2.17 2.17 0 0 1 .833-1.663 1.946 1.946 0 0 1 2.72.42v.007a1.94 1.94 0 0 1 2.71-.437l.014.01a2.17 2.17 0 0 1 .833 1.663c.05 1.5-1.174 2.711-3.042 4.56Z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.649 164.541h44.665a3.1 3.1 0 0 1 3.1 3.1 3.1 3.1 0 0 1-3.1 3.1H60.649a3.1 3.1 0 0 1-3.1-3.1 3.1 3.1 0 0 1 3.1-3.1M60.713 132.748h23.55a3.877 3.877 0 0 1 3.877 3.877 3.877 3.877 0 0 1-3.877 3.877h-23.55a3.877 3.877 0 0 1-3.877-3.877 3.877 3.877 0 0 1 3.877-3.877",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.162 144.767h26.651a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.326 2.326H59.162a2.326 2.326 0 0 1-2.326-2.326 2.326 2.326 0 0 1 2.325-2.327ZM110.742 144.767h13.489a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.326 2.326h-13.489a2.327 2.327 0 0 1-2.327-2.326 2.327 2.327 0 0 1 2.327-2.326M145.6 144.767h31.276a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.326 2.326H145.6a2.33 2.33 0 0 1-2.326-2.326 2.327 2.327 0 0 1 2.326-2.326",
    style: {
      fill: "#f7f7f7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.292 132.748h4.7a3.877 3.877 0 0 1 3.877 3.877 3.877 3.877 0 0 1-3.877 3.877h-4.7a3.877 3.877 0 0 1-3.877-3.877 3.877 3.877 0 0 1 3.877-3.877M146.8 132.748h15.368a3.877 3.877 0 0 1 3.877 3.877 3.877 3.877 0 0 1-3.877 3.877H146.8a3.877 3.877 0 0 1-3.877-3.877 3.877 3.877 0 0 1 3.877-3.877",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.471 144.767h52.263a2.327 2.327 0 0 1 2.326 2.327 2.33 2.33 0 0 1-2.326 2.326h-52.263a2.327 2.327 0 0 1-2.327-2.326 2.327 2.327 0 0 1 2.327-2.327",
    style: {
      fill: "#f7f7f7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.082 144.767h52.263a2.326 2.326 0 0 1 2.326 2.326 2.326 2.326 0 0 1-2.326 2.326h-52.263a2.326 2.326 0 0 1-2.326-2.326 2.326 2.326 0 0 1 2.325-2.327Z",
    style: {
      fill: "#e8e8e8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.021 132.748H229.4a3.877 3.877 0 0 1 3.877 3.877 3.877 3.877 0 0 1-3.877 3.875h-31.379a3.877 3.877 0 0 1-3.877-3.877 3.877 3.877 0 0 1 3.877-3.875M274.633 132.748h31.375a3.877 3.877 0 0 1 3.877 3.877 3.877 3.877 0 0 1-3.877 3.877h-31.375a3.877 3.877 0 0 1-3.877-3.877 3.877 3.877 0 0 1 3.877-3.877",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#no-data_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.077 50.444h335.45a2.077 2.077 0 0 1 2.077 2.077v83.915a2.077 2.077 0 0 1-2.077 2.077H34.077A2.077 2.077 0 0 1 32 136.436V52.521a2.077 2.077 0 0 1 2.077-2.077",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.682 50.444h101.922v88.069H269.682V50.444",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.305 127.008a.73.73 0 0 1-1.032.006l-.006-.006-.043-.042c-2.027-1.973-3.351-3.265-3.3-4.877a2.31 2.31 0 0 1 .9-1.782 2.13 2.13 0 0 1 2.957.457 2.126 2.126 0 0 1 2.957-.457 2.32 2.32 0 0 1 .9 1.782c.054 1.612-1.274 2.9-3.3 4.886Z",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.558 120.234h48.561a3.323 3.323 0 0 1 3.323 3.323 3.325 3.325 0 0 1-3.323 3.324H48.558a3.325 3.325 0 0 1-3.323-3.324 3.323 3.323 0 0 1 3.323-3.323",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.617 86.17h25.665a4.154 4.154 0 0 1 4.155 4.153 4.154 4.154 0 0 1-4.154 4.154H48.617a4.154 4.154 0 0 1-4.154-4.154 4.153 4.153 0 0 1 4.152-4.154Z",
    style: {
      fill: "#e8e8e8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.956 99.048h28.988a2.493 2.493 0 0 1 2.493 2.492 2.493 2.493 0 0 1-2.493 2.493H46.956a2.493 2.493 0 0 1-2.493-2.493 2.493 2.493 0 0 1 2.493-2.492M102.935 99.048h14.7a2.493 2.493 0 0 1 2.493 2.492 2.493 2.493 0 0 1-2.493 2.493h-14.7a2.493 2.493 0 0 1-2.493-2.493 2.493 2.493 0 0 1 2.493-2.492M140.77 99.048h34.007a2.493 2.493 0 0 1 2.493 2.492 2.493 2.493 0 0 1-2.493 2.493H140.77a2.493 2.493 0 0 1-2.493-2.493 2.493 2.493 0 0 1 2.493-2.492",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 86.17h5.2a4.154 4.154 0 0 1 4.154 4.154 4.154 4.154 0 0 1-4.154 4.154h-5.2a4.154 4.154 0 0 1-4.155-4.153 4.154 4.154 0 0 1 4.155-4.155M142.045 86.17h16.786a4.153 4.153 0 0 1 4.154 4.152 4.154 4.154 0 0 1-4.154 4.154h-16.786a4.154 4.154 0 0 1-4.154-4.154 4.154 4.154 0 0 1 4.154-4.154Z",
    style: {
      fill: "#e8e8e8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.978 99.048h56.785a2.493 2.493 0 0 1 2.493 2.492 2.493 2.493 0 0 1-2.493 2.493h-56.785a2.493 2.493 0 0 1-2.493-2.493 2.493 2.493 0 0 1 2.493-2.492",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.125 99.048h56.785a2.493 2.493 0 0 1 2.493 2.492 2.493 2.493 0 0 1-2.493 2.493h-56.785a2.493 2.493 0 0 1-2.493-2.493 2.493 2.493 0 0 1 2.493-2.492",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.639 86.17H231.8a4.154 4.154 0 0 1 4.154 4.154 4.154 4.154 0 0 1-4.154 4.154h-34.161a4.154 4.154 0 0 1-4.154-4.154 4.154 4.154 0 0 1 4.154-4.154M280.786 86.17h34.159a4.154 4.154 0 0 1 4.154 4.154 4.154 4.154 0 0 1-4.154 4.154h-34.159a4.154 4.154 0 0 1-4.154-4.154 4.154 4.154 0 0 1 4.154-4.154",
    style: {
      fill: "#e8e8e8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.535 34.124a37.833 37.833 0 1 0 37.833 37.832 37.875 37.875 0 0 0-37.833-37.832m0 8.9a28.8 28.8 0 0 1 18.087 6.376l-40.778 40.471a28.907 28.907 0 0 1 22.691-46.846Zm0 57.862a28.76 28.76 0 0 1-16.166-4.949l40.266-39.964a28.913 28.913 0 0 1-24.1 44.913",
    style: {
      fill: "#274350"
    }
  }));
};
export default SvgNoData;